module.exports = __webpack_public_path__ + "img/close_icon_msk_9b00d.png";